<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >监控告警</el-breadcrumb-item>
          <el-breadcrumb-item  class="bread" :to="{ path: '/monitor/equipment/equipment-monitor' }">设备监控</el-breadcrumb-item>
          <el-breadcrumb-item >维护记录</el-breadcrumb-item>
        </el-breadcrumb>
    </div>

      <!-- 1.基本信息 -->
      <div class="equipment-message">
        <dv-border-box-12 >
          <div class="base-message">
            <div class="header-common">
              <div class="header-common-left">
                <div class="title">基本信息</div>
              </div>
            </div>
            <div style="margin-right: 2px;margin-left: -2px;">
                <el-descriptions
                :column="2"
                border
                :contentStyle="contentStyle"
                :labelStyle='labelStyle'>
                  <el-descriptions-item label="使用单位" >
                    <span >{{hospitalName}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="所在地区" >
                    <span >{{area.provinceName}}/{{area.cityName}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="产品名称" >
                    <span >{{typeName}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="规格型号" >
                    <span >{{typeModel}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="设备UDI" >
                    <span >{{udi}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="设备使用" >
                      <span>{{surgeryAmount}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="关联维护人员" >
                      <span>{{maintainUser}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="当前状态" >
                    <span>{{statusText}}</span>
                  </el-descriptions-item>
                </el-descriptions>
            </div>
          </div>
        </dv-border-box-12>
      </div>
      <!-- 2.维护记录 -->
      <div class="table-content">
        <div class="header-common">
          <div class="header-common-left">
            <div class="title">维护记录</div>
          </div>
          <header class="header-common-right">
            <el-button
              class="right-button-export"
              @click="exportTable()"
              type="text"
              >
              导出
            </el-button>
          </header>
        </div>
        <div class="table-list">
          <el-table
          v-loading='loading'
            border
            :cell-style="tableCellStyle"
            :header-cell-style="tableHeaderCellStyle"
            :data="tableData"
            :max-height="tableHeight"
            >
            <el-table-column
            type="index"
              label="序号">
            </el-table-column>
            <el-table-column
              prop="faultTime"
              label="故障时间">
            </el-table-column>
            <el-table-column
              prop="faultLog"
              label="故障日志">
            </el-table-column>
            <el-table-column
              prop="maintainStartTime"
              label="开始处理时间">
            </el-table-column>
            <el-table-column
              prop="maintainFinishTime"
              label="结束处理时间"
              >
            </el-table-column>
            <el-table-column
              prop=""
              label="处理时长"
              >
              <template slot-scope="scope" >
                {{scope.row.maintainDuration}}分钟
              </template>
            </el-table-column>
            <el-table-column
              prop="maintainProcess"
              label="维护内容">
            </el-table-column>
            <el-table-column
              prop="maintainerName"
              label="维护人员">
            </el-table-column>
            <el-table-column
              prop="maintainStatusText"
              label="处理状态">
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            background
            layout="prev, pager, next"
            :page-size="PageSize"
            :total="totalLogAmount"
            :current-page="currentPage"
            @current-change="changeCurrentPage"
            @prev-click="prevClicvPage"
            @next-click="nextClickPage"
            style="margin-top: 15px;margin-left: 15px;margin-bottom: 10px;">
          </el-pagination> -->
        </div>

      </div>
  </div>

</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {areaSingleConversionUtil} from '../../../utils/povince_handle.js'

  export default {
    data() {
      return{
        contentStyle:{
          'border':'1px solid #1A3F81',
          'color' : '#fff',
          'font-size': '15px',
          'font-weight': 'solid',
          'border-bottom':'0px solid #1A3F81',
          'border-right':'0px solid #1A3F81'
        },
        labelStyle:{
          'width': '108px',
          'height': '20px',
          'font-size': '14px',
          'font-weight': 'bold',
          'color': '#00FFFF',
          // 'line-height': '50px',
          'background-color':'transparent',
          'border':'1px solid #1A3F81',
          'border-bottom':'0px solid #1A3F81',
        },
        tableHeight:0,

        id:'',//设备ID
        hospitalName:'',
        area:{
          provinceCode:'',
          provinceName:'',
          cityCode:'',
          cityName:'',
        },
        typeName:'',
        typeModel:'',
        udi:'',
        statusText:'',
        maintainUser:'',
        surgeryAmount:'',

        totalLogAmount:1,//总数量
        totalPageAmount:1 ,//总页数
        PageSize:50,
        currentPage:1,

        tableData:[],
        loading:false,
      }
    },
    methods: {
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;text-align:left;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:left;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      changeCurrentPage(page){
        this.currentPage = page
        this.getMaintainRecord()
      },
      prevClicvPage(page){
        this.currentPage = page
        this.getMaintainRecord()
      },
      nextClickPage(page){
        this.currentPage = page
        this.getMaintainRecord()
      },
      getDetail(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/detail';
        const data = {"id":this.id}

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){

              this.udi = obj.data.udi;
              this.typeName = obj.data.typeName;
              this.typeModel = obj.data.typeModel;
              this.area.provinceCode = obj.data.provinceCode;
              this.area.cityCode = obj.data.cityCode;
              this.hospitalName = obj.data.hospitalName;

              areaSingleConversionUtil.codeToName(this.area)

              if(obj.data.status==1){
                this.statusText = '正常'
              }else if(obj.data.status==2){
                this.statusText = '关机'
              }else if(obj.data.status==3){
                this.statusText = '故障'
              }else{
                this.statusText = '手术中'
              }

              if(obj.data.surgeryAmount<=0){
                this.surgeryAmount = 0
              }

              if(obj.data.maintainUser){
                this.maintainUser = obj.data.maintainUser.username;
              }else{
                this.maintainUser = '无'
              }

            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getMaintainRecord(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/maintenance';
        const data = {"id":this.id}

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          this.tableData = []
          var obj = res.data;
            if(obj.code == 0){
                if(obj.data.maintenances){
                  // this.tableData = obj.data.maintenances;
                  var array = obj.data.maintenances;
                  for(var i=0;i<array.length;i++){
                    var element = array[i];
                    if(element.maintainStatus == 1){
                      element.maintainStatusText = '未处理'
                    }else if(element.maintainStatus == 1){
                      element.maintainStatusText = '处理中'
                    }else {
                      element.maintainStatusText = '处理完成'
                    }
                    this.tableData.push(element)
                  }
                }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },

      exportTable(){
        var tableHeader = [['序号','故障时间','故障日志','开始处理时间','结束处理时间','处理时长(分钟)','维护内容','维护人','处理状态']];
        var dataList = [];
        this.tableData.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.faultTime,
            item.faultLog,
            item.maintainStartTime,
            item.maintainFinishTime,
            item.maintainDuration,
            item.maintainProcess,
            item.maintainerName,
            item.maintainStatusText
          ]);
        });

        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(this.udi+'-设备维护记录',tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }
        
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-500 < 300 ? 300 : window.innerHeight-500;
        })
      }
    },
    created() {
      this.id = this.$route.query.id;


    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)

      this.sizeFun()
      this.getDetail()
      this.getMaintainRecord()
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    }
  }
</script>



<style lang="scss" scoped>
.container{
  margin-top: $header-height;
  // height: 100%;

  .bread >>>.el-breadcrumb__inner{
    color: #606266;
    font-weight: 400;
  }

  .equipment-message{
    margin-top: 5px;
    .base-message{
      padding: 6px 2px 20px 6px;
    }
  }

  .table-content{
    margin-top: $main-padding;
    // position: fixed;
    // top: $header-height+345px;
    // right: 20px;
    // left: 230px;
    // bottom: $main-padding;
    // border: 1px #1564BE solid;
    // border-top-left-radius: 18px;
    // border-top-right-radius: 18px;

    .table-list{

    }
  }

  // 公共头部样式
  .header-common{
    height: 45px;
    margin-right:4px;
    border-radius: 12px 12px 0 0 ;
    background: linear-gradient(-90deg, #001940, #1564BE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .header-common-left{
      font-size: 20px;
      font-weight: bold;
      color: #FEFEFE;
      margin-left: 21px;
    }
    .header-common-right{

      .right-button-export{
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/view/monitor/equipment/equipment-monitor-maintainrecord.vue